import { Component, OnInit, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router'
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { deLocale,thLocale  } from 'ngx-bootstrap/locale';
defineLocale('th', deLocale);
import { ScanService } from '../services/scan.service'

import { JwtHelperService } from '@auth0/angular-jwt'

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {
  locale = 'th';

  d1: Date;

  level: string;
  dep: string;
  sup : string ;
  date1: string;
  ds1: string;
  scan_data: any = [];

  ds_1: string;
  rowHeight: number = 8;
  p: number = 1;

  jwtHelper = new JwtHelperService();

  constructor(private datePipe: DatePipe, private scanService: ScanService, private router: Router,
    private localeService: BsLocaleService) {
    defineLocale('th', thLocale);
    this.localeService.use('th');
  }
  bsConfig: Partial<BsDatepickerConfig>;
  ngOnInit() {


    const token = sessionStorage.getItem('token');
    const decoded: any = this.jwtHelper.decodeToken(token);

    this.dep = decoded.deptid;

    if (token) {
      this.d1 = new Date();
      this.date1 = this.datePipe.transform(this.d1, "dd-MM-yyyy")

      this.level = sessionStorage.getItem('level');
      this.sup = sessionStorage.getItem('sup');

      this.bsConfig = Object.assign({});
    } else {
      this.router.navigate(['/login']);
    }


  }

  async getScan() {
    this.ds_1 = this.datePipe.transform(this.ds1, "dd-MM-yyyy");

    const _d = this.ds_1.substring(0,2);
    const _m = this.ds_1.substring(2,6);
    const _y = this.ds_1.substring(6,10);

    const dmy = _y+_m+_d;
    console.log(this.ds_1.substring(0,2));
    try {
      const rs: any = await this.scanService.get_one_scan(this.dep, dmy, this.level , this.sup);
     
      if (rs.ok == true) {
        this.scan_data = rs.results;
      }
    } catch (error) {
      console.log(error);
    }
  }

  getColor(ppp) { (2)
    switch (ppp) {
      case 'ช':
        return 'green';
      case 'ช/บ':
        return 'orange';
      case 'บ':
        return 'orange';
      case 'ด':
        return 'red';
    }
  }

}
